import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RowVertical, Spreadsheet, SubTitleText } from '../../DTInfoWidget.styles';
import { Skeleton } from '../../../../styled/skeleton';
import {
  getBrandOfSelectedTicket,
  getSelectedOrderFromOrdersSearch,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../extractFromState';
import { getRemediations } from '../../../../../api/orders/rbi';
import { handleError } from '../../../../../services/ErrorService/ErrorService';
import RemediationsTable from './RemediationsTable/RemediationsTable';

const DTRbiRemediationsWidget = () => {
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const brandName = useSelector(getBrandOfSelectedTicket);
  const selectedOrder = useSelector(getSelectedOrderFromOrdersSearch);

  const orderRemediations = selectedOrder.remediations ?? [];

  const [isLoading, setIsLoading] = useState(false);
  const [remediations, setRemediations] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const result = await getRemediations({
          simplrAccountId,
          customerEmail: selectedOrder.userDetails.email,
          brandName,
        });
        setRemediations(result);
      } catch (error) {
        handleError({ error, showPopup: true });
      } finally {
        setIsLoading(false);
      }
    })();
  }, [simplrAccountId, selectedOrder, brandName]);

  const renderSkeletonUI = () => {
    return (
      <RowVertical data-testid={'skeleton'}>
        <Skeleton height="18px" width="100%" />
        <Skeleton height="18px" width="100%" />
        <Skeleton height="18px" width="75%" />
      </RowVertical>
    );
  };

  if (isLoading) {
    return renderSkeletonUI();
  }

  return (
    <>
      <Spreadsheet className="fs-block">
        <SubTitleText>ORDER REMEDIATIONS</SubTitleText>
        <RemediationsTable remediations={orderRemediations} />
      </Spreadsheet>
      <SubTitleText style={{ marginTop: '15px' }}>ALL REMEDIATIONS</SubTitleText>
      <RemediationsTable remediations={remediations} />
    </>
  );
};

export default DTRbiRemediationsWidget;
